import { ServerError } from '@texas/types';
import { Branch } from './branchesApi';
import { Role } from './userApi';
import { httpClient } from '../httpClient/httpClient';
import { JobRecord } from './jobRecordsApi';
import type { WeightUnit } from '@texas/resources/weightUnits';

export interface Session {
  currentUser: CurrentUser;
  branches: Branch[];
}

export interface CurrentUser {
  name: string;
  id: number;
  organizationId: number;
  email: string;
  role: Role | null;
  branchId: number | null;
  branchIdentifier?: string;
  betaFeatures: boolean;
  preferredWeightUnit: WeightUnit;
}

export enum SessionStatus {
  Fetching,
  Active,
  Error,
  Inactive,
}

export interface SessionPollData {
  unconfirmedTasksCount: number;
  runningJobs: JobRecord[];
}

export type SessionState =
  | {
      status: SessionStatus.Fetching;
    }
  | {
      status: SessionStatus.Inactive;
    }
  | {
      status: SessionStatus.Active;
      session: Session;
    }
  | {
      status: SessionStatus.Error;
      error: ServerError;
    };

export const sessionApi = {
  getSession: () => httpClient.get<Session>('session'),
  getServerState: () => httpClient.get<SessionPollData>('session/state'),
};
